/* tslint:disable */
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackFilter,  } from '../../models/BaseModels';
import { JSONSearchParams } from '../core/search.params';
import { ErrorHandler } from '../core/error.service';
import { Observable, Subject } from 'rxjs';
import { ViewLPU } from '../../models/ViewLPU';


/**
 * Api services for the `ViewLPU` model.
 */

export class ViewLPUApi extends BaseLoopBackApi {

  constructor(
     
  ) {
    
    super();
    
  }



  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewLPU`.
   */
  getModelName() {
    return "ViewLPU";
  }
}




// WEBPACK FOOTER //
// ./src/sdk/services/custom/ViewLPU.js